"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IRegistryReader = void 0;
class IRegistryReader {
    constructor() { }
}
exports.IRegistryReader = IRegistryReader;
//# sourceMappingURL=IRegistryReader.js.map